// extracted by mini-css-extract-plugin
export default {"maindiv":"MealDeals_maindiv__3WRpr","componentdiv":"MealDeals_componentdiv__IVuj8"};